import variables from 'styles/variables.export.module.scss';

export const fromPixels = (source: string) => +source.replace('px', '');

/**
 * Constants from `variables.scss`
 */
export const cssVariables = {
  halfBlockMaxWidth: fromPixels(variables.halfBlockMaxWidth),
  headerGroupPadding: fromPixels(variables.headerGroupPadding),
  reportMediumBreakpoint: fromPixels(variables.reportMediumBreakpoint),
  reportWideBreakpoint: fromPixels(variables.reportWideBreakpoint),
  breakPointExtraLarge: fromPixels(variables.breakPointExtraLarge),
  widgetBaseHeight: fromPixels(variables.widgetBaseHeight),
  widgetBilledColor: variables.widgetBilledColor,
  widgetBillableColor: variables.widgetBillableColor,
  widgetNonBillableColor: variables.widgetNonBillableColor,
  widgetUnbilledColor: variables.widgetUnbilledColor,
  widgetOtherColor: variables.widgetOtherColor,
  mainNavWidth: fromPixels(variables.mainNavWidth),
};
